<template>
  <div class="b-skeleton-wrapper-compat placeholder-glow">
    <slot
      v-if="loading"
      name="loading"
    />
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'BSkeletonWrapper',
  props: {
    loading: { type: Boolean, default: false },
  },
}
</script>
